import React, { useEffect, useState } from 'react';
import { Button, Stack } from '@moda/om';
import { FulfillmentTypes, Availability } from '@moda/portal-stanchions';
import {
  ProductDetailsFragment,
  ProductDetailsVariantFragment,
  SizeInventoryFragment
} from '../../../generated/types';
import { useInEurope } from '../../../hooks/useInEurope';
import { AddToBagButton } from '../../AddToBagButton';
import { PdpDeliveryInfo } from '../../PdpInfoContainer/PdpDeliveryInfo';
import { ProductDetailsFavoriteSection } from '../ProductDetailsFavoriteSection';
import { ProductDetailsFinalSaleInformation } from '../ProductDetailsFinalSaleInformation';
import { ContactToPurchaseModal } from '../../ContactToPurchaseModal/ContactToPurchaseModal';
import { tc } from '../../../lib/trackingContext';
import { useUrlParams } from '../../../hooks/useUrlParams';

interface Props {
  variant: ProductDetailsFragment;
  activeVariant: ProductDetailsVariantFragment;
  size: SizeInventoryFragment | null;
  quantity?: number;
  customizationMessage: string;
  isCustomizationValid: boolean;
  selectedSize: SizeInventoryFragment | null;
  isSpectacularGift: boolean;
}

export const ProductDetailsCallToActionSection: React.FC<Props> = ({
  variant,
  activeVariant,
  size,
  quantity,
  customizationMessage,
  isCustomizationValid,
  selectedSize,
  isSpectacularGift
}) => {
  const inEurope = useInEurope();

  const [showRequestModal, setShowRequestModal] = useState(false);

  const handleClick = () => {
    setShowRequestModal(true);
    tc.track('Contact To Purchase Open', {
      addToTrackingEvent: {
        label: 'Contact To Purchase Button',
        location: location.pathname
      }
    });
  };

  const showDeliveryWindow =
    (variant.availability === String(Availability.Preorder) ||
      variant.availability === String(Availability.Trunkshow)) &&
    variant.fulfilmentType !== FulfillmentTypes.DropShip &&
    variant.fulfilmentType !== FulfillmentTypes.MiraklDropship &&
    !variant.customerDeliveryNotes;
  const { params } = useUrlParams();

  useEffect(() => {
    if (params.contact === 'true') {
      setShowRequestModal(true);
    }
  }, [params.contact]);

  if (size && !size.canSell) {
    return null;
  }

  return (
    <>
      <Stack space={3} className="ProductDetailsCallToActionSection">
        {variant.available && !isSpectacularGift && (
          <AddToBagButton
            activeVariantId={activeVariant.id}
            customization={customizationMessage}
            isCustomizationValid={isCustomizationValid}
            size={size}
            quantity={quantity}
            validatesSizePresenceOn="submit"
            variant={variant}
          >
            {showDeliveryWindow && (
              <PdpDeliveryInfo
                deliveryDates={
                  selectedSize?.processDeliveryDates || variant.masterVariant.processDeliveryDates
                }
                fulfilmentType={variant.fulfilmentType}
              />
            )}
          </AddToBagButton>
        )}

        {isSpectacularGift && <Button onClick={() => handleClick()}>CONTACT US TO PURCHASE</Button>}

        <ProductDetailsFavoriteSection size={size} variant={variant} />
        {!inEurope && (
          <ProductDetailsFinalSaleInformation returnPolicy={activeVariant.returnPolicy} />
        )}
      </Stack>

      {isSpectacularGift && (
        <ContactToPurchaseModal
          show={showRequestModal}
          onClose={() => setShowRequestModal(false)}
        />
      )}
    </>
  );
};
